import {Button, NonIdealState} from '@blueprintjs/core';
import {ReactElement, ReactNode} from 'react';

interface Props {
	action?: ReactElement,
}

export default function NoSearchResults({action}: Props): ReactElement {
	return (
		<NonIdealState
			icon="search-text"
			title="There's Nothing Here"
			description={(
				<>
					No items matched your search.
				</>
			)}
			action={action}
		/>
	)
}
